import React from "react";

const BankGenericSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z"
        fill="#E4F4FD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H22C22.5523 15 23 14.5523 23 14V2C23 1.44771 22.5523 1 22 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.895431 23.1046 0 22 0H2Z"
        fill="#15749D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 6C17.5 6.27614 17.2761 6.5 17 6.5H12C11.7238 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.7238 5.5 12 5.5H17C17.2761 5.5 17.5 5.72386 17.5 6Z"
        fill="#15749D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.583 9.70019C15.5309 9.77382 15.5 9.87763 15.5 9.99998C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 9.99998C14.5 9.72073 14.5691 9.40159 14.767 9.12223C14.9715 8.8335 15.2863 8.62636 15.7006 8.54231C16.4861 8.38289 17.6234 8.66352 19.2428 9.56287C19.4842 9.69694 19.5712 10.0013 19.4371 10.2427C19.303 10.4842 18.9986 10.5712 18.7572 10.4371C17.1765 9.55919 16.3139 9.43823 15.8994 9.52233C15.7137 9.56003 15.6285 9.63593 15.583 9.70019Z"
        fill="#15749D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7306 9.51498C12.6173 9.54562 12.5 9.67145 12.5 9.99999C12.5 10.2761 12.2761 10.5 12 10.5C11.7239 10.5 11.5 10.2761 11.5 9.99999C11.5 9.52534 11.6827 8.76255 12.4694 8.54968C12.8296 8.45222 13.2416 8.50118 13.6926 8.66848C14.1458 8.83659 14.6755 9.13752 15.2976 9.59817C15.5195 9.7625 15.5662 10.0756 15.4018 10.2975C15.2375 10.5195 14.9244 10.5661 14.7024 10.4018C14.1245 9.97384 13.6792 9.73007 13.3449 9.60606C13.0084 9.48124 12.8204 9.49069 12.7306 9.51498Z"
        fill="#15749D"
      />
      <path
        d="M7.54628 4H6.28841C6.23063 4 6.17522 4.02295 6.13437 4.06381C6.09351 4.10466 6.07056 4.16008 6.07056 4.21785V4.79803C4.90757 4.9927 4.21781 5.7639 4.21781 6.77533V6.79428C4.21781 8.08815 5.25783 8.46702 6.60474 8.77581C7.47427 8.9823 7.68075 9.11869 7.68075 9.38959V9.40853C7.68075 9.67943 7.4288 9.84235 6.94952 9.84235C6.26611 9.83533 5.60266 9.61109 5.05513 9.20205C5.00997 9.17064 4.95459 9.15747 4.90013 9.16521C4.84566 9.17294 4.79613 9.20099 4.7615 9.24372L4.05679 10.0829C4.03699 10.1051 4.02203 10.1312 4.01286 10.1595C4.0037 10.1878 4.00052 10.2177 4.00355 10.2473C4.00658 10.2769 4.01575 10.3055 4.03046 10.3313C4.04517 10.3572 4.0651 10.3797 4.08899 10.3974C4.67485 10.8412 5.35705 11.132 6.07428 11.2499V11.8106C6.07428 11.8608 6.09423 11.909 6.12976 11.9445C6.16528 11.98 6.21348 12 6.26372 12H7.57274C7.59809 12.0008 7.62333 11.9964 7.64698 11.9872C7.67062 11.9781 7.69218 11.9642 7.71037 11.9466C7.72857 11.9289 7.74304 11.9078 7.75291 11.8844C7.76279 11.861 7.76787 11.8359 7.76786 11.8106V11.2132C8.80451 10.9702 9.45011 10.2735 9.45011 9.24562V9.22857C9.45011 8.04268 8.54459 7.57287 7.09728 7.25651C6.21071 7.0576 5.99285 6.93067 5.99285 6.64083V6.62189C5.99285 6.38698 6.20124 6.2146 6.62747 6.2146C7.19674 6.22983 7.7502 6.40512 8.22444 6.7204C8.27194 6.75009 8.32911 6.76017 8.3839 6.74851C8.43868 6.73684 8.48679 6.70435 8.51807 6.65788L9.1527 5.76184C9.18577 5.71625 9.19954 5.65947 9.19103 5.60379C9.18252 5.54812 9.1524 5.49804 9.10722 5.46442C8.69767 5.18117 8.242 4.97799 7.76414 4.86188V4.21785C7.76414 4.16008 7.74119 4.10466 7.70033 4.06381C7.65948 4.02295 7.60406 4 7.54628 4Z"
        fill="#15749D"
      />
    </svg>
  );
};

export default BankGenericSmallIcon;
